import React, { useEffect, useState, useCallback, useRef, useReducer } from "react";
import SearchIcon from '@mui/icons-material/Search';
import Grid from '@mui/material/Unstable_Grid2';
import EventsInformation from "../components/EventsInformation";
import LoaderComponent from "../components/LoaderComponent";
import ChangeLogSocket from "../components/ChangeLogSocket";
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import ExternalWindowComponent from "../components/ExternalWindowComponent";
import { Box, Button, Chip, InputAdornment, List, ListItem, ListItemText, OutlinedInput, Stack, Tab, Typography } from "@mui/material";
import swal from "sweetalert";
import FavParamInformation from "../components/FavParamInformation";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { disconnectSocketConnection, readSocketFile, updateSocketConnection } from "../components/CommonApi";
import { useDispatch } from 'react-redux';
import { sessionDisconnect, sessionUnSubscribe, acknowledgeRequest, updatedDataRequest, getSocket, sessionSubscribe,chatMessagesRequest, changeLogsRequest, eventsRequest, createChatMessage, requestInitialFileData, initialDataLoadedAck, downloadLogsFile, changeParamSettings, socketRemoveListeners, userLeftSession, beforeUnloadHandler, socketDisconnect } from "../components/SocketService";
import ChatComponent from "../components/ChatComponent";
import { createRoot } from 'react-dom/client';
import { handleEndSessionAlert, handleSessionCommunicatingAlert, handleSessionInterruptAlert, handleUserLeft } from "../components/SweetAlertMessages";
import { downloadSocketLogFile } from "../api/remotedeviceapi";
import MeteringGroup from "../components/MeteringGroup";

const { socketInformation } = window;

const DeviceData = () => {
    const socket                                        = useRef();
    const [tabValue, setTabValue]                       = useState('1');
    const serialNumber                                  = socketInformation?.serial_number;
    const [eventsData, setEventsData]                   = useState([]);
    const [eventCountData, setEventCountData]           = useState([]);
    const [changeLogMessages, setChangeLogMessages]     = useState([]);
    const [updatedParam, setUpdatedParam]               = useState([]);
    const [initialFileLoader, setInitialFileLoader]     = useState(true);
    const [input, setInput]                             = React.useState("");
    const [chatMessages, setChatMessages]               = React.useState([]);
    const meteringGroupsRef                             = useRef(new Map());
    const editingParamsRef                              = useRef(new Set());
    const [, forceUpdate]                               = useReducer(x => x + 1, 0);
    const [expandedGroups, setExpandedGroups]           = useState({});
    const [searchTerm, setSearchTerm]                   = useState("");
    const favParamRef                                   = useRef(new Map());
    const dispatch                                      = useDispatch();

    // Effect used to filter the parameters when searched for particular parameter
    // useEffect(() => {
    //     if (searchValue) {
    //         setParametersData(preFilteredParametersData.filter((group) => group.parameters.some((subParam) => subParam.label.toLowerCase() === searchValue)).map(group => Object.assign({}, group, { 'parameters': group.parameters.filter(subParam => subParam.label.toLowerCase() === searchValue) })));
    //     } else {
    //         setParametersData(preFilteredParametersData);
    //     }
    // }, [searchValue, preFilteredParametersData]);

    // Function used to send the chat message to app client
    const handleSend = () => {
        if (input.trim() !== "") {
            setInput("");
            createChatMessage(serialNumber,input)
        }
    };

    // Function changing the state of chat message
    const handleInputChange = (event) => {
        setInput(event.target.value);
    };

    // Function used for acknowledging the initial data
    const acknowledgeInitialDataLoaded = useCallback(() => {
        initialDataLoadedAck(serialNumber);
    }, [serialNumber]);

    // Function used to sedn the download files request
    const fileDownloadRequest = (event, fileType) => {
        setInitialFileLoader(true);
        downloadLogsFile(serialNumber,fileType)
    }

    // Function used getting the intitial data from the file
    const loadinitialData = useCallback(async (data) => {
        let result = await readSocketFile(data);
        setInitialFileLoader(false);
        if (result.status) {
            if (result?.content.length > 0) {
                let messageInfo = JSON.parse(result.content);setEventCountData(messageInfo?.event?.event_type_meta_data);
                setEventsData(messageInfo?.event?.events);
                const groupsMap = new Map();
                messageInfo?.metering_groups?.forEach(group => {
                groupsMap.set(group.id, {
                    ...group,
                    // optionally clone parameters if needed
                    parameters: group?.parameters.map(param => ({ ...param })),
                });
                });
                meteringGroupsRef.current = groupsMap;
            }
            acknowledgeInitialDataLoaded();
        } else {
            setInitialFileLoader(false);
            handleSessionCommunicatingAlert(serialNumber,socketInformation?.row_id);
        }
    }, [serialNumber,acknowledgeInitialDataLoaded]);


    const toggleGroup = (groupId) => {
        setExpandedGroups(prev => ({
          ...prev,
          [groupId]: !prev[groupId],
        }));
    };
    
    
    // Effect used for creating the socket connection and adding the event listeners
    useEffect(() => {
        if(!serialNumber){
            setInitialFileLoader(false);
            handleSessionInterruptAlert();
            return;
        }
        socket.current = getSocket();
        socket.current.on('connect', async () => {
            sessionSubscribe(serialNumber);
            let updateParam = {'row_id':socketInformation.row_id,'room_id': serialNumber,'web_client_id':socket?.current?.id}
            await updateSocketConnection(updateParam);
        })
        acknowledgeSocketRequests();
        checkUpdateParam();
        getEventsData();
        getChangeLogData();
        getChatMessages();
        checkUserLeftSession();
        //checkSocketDisconnect();
        return () => {
            socketRemoveListeners();
            window.opener.sessionStorage.removeItem('connection');
            sessionStorage.removeItem('connection');
            sessionUnSubscribe(serialNumber);
            sessionDisconnect('disconnect');
        } 
        // eslint-disable-next-line
    }, []);

    const checkUpdateParam = () => {
        updatedDataRequest(response => {
            const update = response?.data?.message;
            if (!update || update.type !== "data_update" || update.topic !== "parameter") return;
            const entity = update.data?.entity;
            if (!entity) return;
            const paramId = entity.id;
            const newValue = entity.value;
            if(tabValue === '1'){
                const groupId = entity.metering_group_id?.toString();
                const group = meteringGroupsRef.current.get(groupId);
                if (!group) return;
                const param = group.parameters.find(p => p.id === paramId);
                if (!param) return;
                // Skip update if user is editing
                if (!editingParamsRef.current.has(paramId)) {
                    param.value = newValue;
                    forceUpdate();
                }
            }
        })
    }

    useEffect(() => {
        if(tabValue === '2'){
            updatedDataRequest(response => {
                const update = response?.data?.message;
                if (!update || update.type !== "data_update" || update.topic !== "parameter") return;
                const entity = update.data?.entity;
                if (!entity) return;
                const paramId = entity.id;
                const newValue = entity.value;
                if(!favParamRef.current.has(paramId)) return;
                let favData = favParamRef.current.get(paramId);
                if (!editingParamsRef.current.has(paramId)) {
                    favData.value = newValue;
                    forceUpdate();
                }
            })
        }
    },[tabValue])



    // For now not using this function so commented out.
    /*const checkSocketDisconnect = () => {
        socketDisconnect(response => {
            //console.log('socketDisconnect -- ',response)
            setInitialFileLoader(false);
            handleSessionCommunicatingAlert(serialNumber,socketInformation.row_id);
        })
    }*/


    // Function called when user_left the room
    const checkUserLeftSession = () => {
        userLeftSession(async response => {
            console.log('userLeftSession web -- ',response)
            if(response !== "ping timeout" || response !== "transport close"){
                setInitialFileLoader(false);
                let param = {"room_id":serialNumber,"row_id":socketInformation.row_id,"session_status":"disconnect"}
                await disconnectSocketConnection(param);
                handleUserLeft();
            } 
        })
    }

    // Function change the changelog data state
    const getChangeLogData = () => {
        changeLogsRequest(response => {
            //console.log('ChangeLogData')
            setChangeLogMessages((prevMessage) => [response?.data?.message?.data?.entity, ...prevMessage]);
        });
    }

    // Function change the chat message state
    const getChatMessages = () => {
        chatMessagesRequest(response => {
            //console.log('chat messages')
            setChatMessages((prevMessage) => [ ...prevMessage,response?.data?.message?.data?.entity]);
        })
    }

    // Function change the events state
    const getEventsData = () => {
        eventsRequest(response => {
            //console.log('events data')
            setEventsData((prevMessage) => [response?.data?.message?.data?.entity, ...prevMessage]);
            setEventCountData(response?.data?.message?.data?.event_type_meta_data);
        })
    }

    // Function acknowledging the requests for user connection and files
    const acknowledgeSocketRequests = () => {
        acknowledgeRequest(response => {
            //console.log('acknowledgeSocketRequests')
            if (response?.data?.message?.topic === 'session') {
                if (response.data.message.data.entity?.type === 'user_connected') {
                    //console.log('user_connected requestInitialFileData')
                    requestInitialFileData(response.recipientId);
                }
                if (response.data.message.data?.label === 'preparing') {
                    //console.log('user_connected preparing')
                    setInitialFileLoader(true);
                }
                if (response.data.message.data?.label === 'ready') {
                    //console.log('user_connected ready')
                    loadinitialData(response.data.message.data?.entity);
                }
            }

            if (response?.data?.message?.topic === 'file') {
                if (response?.data?.message?.data?.label === 'preparing') {
                    setInitialFileLoader(true);
                }
                if (response?.data?.message?.data?.label === 'ready') {
                    dispatch(downloadSocketLogFile(response?.data?.message?.data?.entity?.row_id, response?.data?.message?.data?.entity?.file_name, response?.data?.message?.data?.entity?.type));
                    setInitialFileLoader(false);
                }
            }
        });
    }

    useEffect(() => {
        if (changeLogMessages.length > 0) {
            updateChangeLogData(changeLogMessages)
        }
    }, [changeLogMessages]);


    // Event listener called when child window closes
    window.addEventListener('beforeunload',  () => {
        beforeUnloadHandler(serialNumber);
    });

    // Event listener called when child window closes on mobile browser
    window.addEventListener('pagehide',  () => {
        beforeUnloadHandler(serialNumber);
    });

    // Function to send data to Child window of Change Log
    const updateChangeLogData = (changeLogArray) => {
        window.postMessage({ type: 'initialdata', data: changeLogArray }, '*')
    }

    const handleChangeLogClick = () => {
        const newWindow = window.open('', '_blank', 'width=1320,height=800');
        newWindow.document.title = 'Change Log';
        const root  = createRoot(newWindow.document.body.appendChild(newWindow.document.createElement('div')))
        root.render(<ExternalWindowComponent data={changeLogMessages} />)
    }

    const handleAddFavParam = (param) => {
        favParamRef.current.set(param?.id,{...param});
        swal("Success", "Parameter added to Favorite list", "success");
    }

    const handleRemoveFavParam = (param) => {
        favParamRef.current.delete(param?.id);
        swal("Success", "Parameter removed from Favorite list", "success");
    }

    const handleChangeTab = (event, newValue) => {
        if(newValue === '1'){
            setSearchTerm('');
        }
        setTabValue(newValue);
    };

    const handleEndSession =  () => {
        handleEndSessionAlert(serialNumber,socketInformation.row_id);
    }


    const handleUpdateParamValWeb =  () => {
        //console.log('updatedParam',updatedParam);
        changeParamSettings(serialNumber,updatedParam);
        setUpdatedParam([]);
    }

    const handleChange = (groupId, paraminfo, newValue) => {
        const group = meteringGroupsRef.current.get(groupId);
        if (!group) return;
        const param = group.parameters.find(p => p.id === paraminfo?.id);
        if (!param) return;
        param.value = newValue;
        setUpdatedParam((prev) => [...prev, paraminfo]);
        forceUpdate();
    };

    const handleFocus = (paramId) => {
        editingParamsRef.current.add(paramId);
    };

    const handleBlur = (paramId) => {
        editingParamsRef.current.delete(paramId);
    };

    const handleChangeFavParam = (paraminfo, newValue) => {
        const param = favParamRef.current.get(paraminfo?.id);
        if (!param) return;
        param.value = newValue;
        //setUpdatedParam((prev) =>  ({...prev, [paramId]: newValue }));
        setUpdatedParam((prev) => [...prev, paraminfo]);
        forceUpdate();
    };

    const filteredGroups = React.useMemo(() => {
        const allGroups = Array.from(meteringGroupsRef.current.values());
        if (!searchTerm.trim()) {
           // console.log('Returning all groups:', allGroups);
            return allGroups;
        }

        const lowerSearch = searchTerm.toLowerCase();
        const groups = [];
        for (const group of meteringGroupsRef.current.values()) {
          // Filter params in group by label includes searchTerm
          const filteredParams = group.parameters.filter(param =>
            param.label.toLowerCase().includes(lowerSearch)
          );
          if (filteredParams.length > 0) {
            groups.push({
              ...group,
              parameters: filteredParams,
            });
          }
        }
        return groups;
    }, [searchTerm,meteringGroupsRef.current]);

//    console.log('tabValue',tabValue);
//    console.log('typeof tabValue',typeof tabValue);
//    console.log('lenght',Array.from(favParamRef.current.values()).length)
//    console.log('length of param',filteredGroups.length)
    return (
        <Box sx={{ flexGrow: 1 }} >
            {initialFileLoader ? <LoaderComponent /> : <></>}
            <Grid container sx={{ pb: 1 }}>
                <Grid xs={12} sm={6} md={6} xl={8} justifyContent="flex-start">
                    <Typography sx={{ fontWeight: 700, fontSize: '20px' }} component="h1">Remote Console</Typography>
                </Grid>
                <Grid xs={12} sm={6} md={6} xl={4} >
                    <Box display="flex" className="remoteHeading" justifyContent="flex-end">
                        <Typography component="span" sx={{ pt: 1, fontSize: '0.85rem' }}> Observing</Typography> &nbsp;
                        <Typography component="span" sx={{ color: '#1558CD', pr: 1, pt: 1, fontSize: '0.85rem' }}> test.user@rehlko.com</Typography>
                        <Button
                            onClick={handleEndSession}
                            variant="contained"
                            size="medium"
                            color="error"
                        ><Typography fontSize="0.85rem" fontWeight="500" component="span">End Session</Typography></Button>
                    </Box>
                </Grid>
            </Grid>
            <List 
                component={Stack} 
                className="rowHeading"
                direction="row"
                sx={{
                    pt: 0, pb: 0, borderRadius: '4px',
                    marginBottom: '8px',
                    border: `1px solid #EAEAEA`,
                    bgcolor: '#EAEAEA',
                }} 
            >
                <ListItem><ListItemText primary={<Typography component="span">Parameters</Typography>} /></ListItem>
                <ListItem><ListItemText primary={<Typography component="span">Events</Typography>} /></ListItem>
                <ListItem sx={{display: { md: "block", sm: "none", xs: "none"}}} ><ListItemText primary={<Typography component="span">Export Files</Typography>} /></ListItem>
            </List>
            
            <Grid container spacing={3}>
                <Grid xs={12} sm={12} md={12} lg={4} >
                    <Box 
                        className="separateRowHeading"
                        component={Stack} 
                        direction="row" 
                        sx={{ 
                            pt: 0.5, 
                            pb: 0.5, 
                            borderRadius: '4px',
                            mb: 0.5,
                            border: `1px solid #EAEAEA`,
                            bgcolor: '#EAEAEA',
                            mt:1
                        }}
                    >
                        <Typography sx={{ fontWeight: 500, pl: 2,fontSize:'0.90rem' }}>Parameters</Typography>
                    </Box>
                    <TabContext value={tabValue}>
                        <TabList
                            sx={{
                                border: `1px solid #EAEAEA`,
                                bgcolor: '#EAEAEA',
                                borderRadius: `4px`,
                                minHeight: '0px !important'
                            }}
                            onChange={handleChangeTab}
                            aria-label=""
                        >
                            <Tab className="paramTab" label="All" value="1" />
                            <Tab className="paramTab" label="Favorites" value="2" />
                        </TabList>
                        <TabPanel sx={{ padding: '8px 0' }} value="1">
                            <OutlinedInput
                                className="searchParams"
                                fullWidth
                                placeholder="Search Param"
                                endAdornment={<InputAdornment position="end"><SearchIcon sx={{ color: 'action.active', mr: 1, my: 0.5,fontSize:'1.2rem' }} /> </InputAdornment>}
                                onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
                            />
                            
                            {/* {[...meteringGroupsRef.current.values()].map(group => ( */}
                            {filteredGroups.map(group => (
                                <MeteringGroup
                                    key={group.id}
                                    group={group}
                                    expanded={!!expandedGroups[group.id]}
                                    toggle={() => toggleGroup(group.id)}
                                    onChange={handleChange}
                                    onFocus={handleFocus}
                                    onBlur={handleBlur}
                                    expandedGroups={expandedGroups}
                                    handleAddFavParam={handleAddFavParam}
                                    handleRemoveFavParam={handleRemoveFavParam}
                                    favParamData={favParamRef}
                                />
                            ))}
                        </TabPanel>
                        <TabPanel sx={{ padding: '16px 0' }} value="2">
                            <FavParamInformation
                                handleRemoveFavParam={handleRemoveFavParam}
                                favData={Array.from(favParamRef.current.values())}
                                onChange={handleChangeFavParam}
                                onFocus={handleFocus}
                                onBlur={handleBlur}
                            />
                        </TabPanel>
                    </TabContext>
                    {(tabValue === '1' && filteredGroups.length > 0)  &&
                        <Box justifyContent='center' display='flex'>
                            <Button
                            sx={{ paddingTop: '4px',fontSize:'12px' }}
                            color="primary"
                            variant="contained"
                            onClick={handleUpdateParamValWeb}
                            >
                                Save Changes
                            </Button>
                        </Box>
                    }
                    {(tabValue === '2' && Array.from(favParamRef.current.values()).length > 0)&&
                        <Box justifyContent='center' display='flex'>
                            <Button
                            sx={{ paddingTop: '4px',fontSize:'12px' }}
                            color="primary"
                            variant="contained"
                            onClick={handleUpdateParamValWeb}
                            >
                                Save Changes
                            </Button>
                        </Box>
                    }
                </Grid>
                <Grid xs={12} sm={12} md={12} lg={4} >
                    <Box 
                        className="separateRowHeading"
                        component={Stack} 
                        direction="row" 
                        sx={{ 
                            pt: 0.5, 
                            pb: 0.5, 
                            borderRadius: '4px',
                            mb: 0.5,
                            border: `1px solid #EAEAEA`,
                            bgcolor: '#EAEAEA',
                            mt:1
                        }}
                    >
                        <Typography sx={{ fontWeight: 500, pl: 2,fontSize:'0.90rem' }}>Events</Typography>
                    </Box>
                    <EventsInformation eventCount={eventCountData} events={eventsData} />
                </Grid>
                <Grid xs={12} sm={12} md={12} lg={4} >
                    <Box 
                        className="separateRowHeading"
                        component={Stack} 
                        direction="row" 
                        sx={{ 
                            pt: 0.5, 
                            pb: 0.5, 
                            borderRadius: '4px',
                            mb: 1,
                            border: `1px solid #EAEAEA`,
                            bgcolor: '#EAEAEA',
                            mt:1,
                        }}
                    >
                        <Typography sx={{ fontWeight: 500, pl: 2,fontSize:'0.90rem' }}>Export Files</Typography>
                    </Box>
                    <Chip className="fileDownloadButton" onClick={(e) => { fileDownloadRequest(e, 'event_file') }} label="Event History" />
                    <Chip className="fileDownloadButton" onClick={(e) => { fileDownloadRequest(e, 'config_file') }} label="Configuration File" />
                    <Chip className="fileDownloadButton" onClick={(e) => { fileDownloadRequest(e, 'freeze_file') }} label="Freeze Frame" />
                    <ChatComponent messages={chatMessages} handleInputChange={handleInputChange} input={input} handleSend={handleSend} />
                </Grid>
                <Grid xs={12} sm={12} md={12} lg={12} >
                    <List sx={{ pt: 0, pb: 0, bgcolor: 'background.paper' }}>
                        <ListItem
                            sx={{
                                borderRadius: '4px',
                                marginBottom: '8px',
                                border: `1px solid #EAEAEA`,
                                bgcolor: '#EAEAEA',
                                pt: 0,
                                pb: 0
                            }} >
                            <ListItemText sx={{ mt: 0, mb: 0 }} primary={<Typography sx={{ fontWeight: 500 }} component="span">Change Log </Typography>} />
                            <ListItemText onClick={handleChangeLogClick} sx={{ mt: 0, mb: 0, display: 'flex', justifyContent: 'flex-end' }} primary={<OpenInFullIcon sx={{ mt: 0.5, cursor: 'pointer' }} fontSize="small" />} />
                        </ListItem>
                    </List>
                    <ChangeLogSocket changeLogData={changeLogMessages} />
                </Grid>
            </Grid>
        </Box>
    )
}

export default DeviceData